import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../math/Forces';

export default class Sparkle extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Sparkle_3);

    this.mass = 1.0;
    this.gravity = 20;
    this.k = 0.0;

    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.curAnim = 1;
    this.maxAnim = 4;
    this.animationWaiter = .5;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();

    this.leftLimit = 0;
    this.rightLimit = this.scene.scale.width;
    this.bottomLimit = this.scene.scale.height - 60;
    this.topLimit = -200;
  }

  reset (x,y,vx,vy,lifetime,fastforce) {
    this.pos.x = x;
    this.pos.y = y;
    this.vel.x = vx;
    this.vel.y = vy;
    this.gravityForce.x = -Phaser.Math.Between(200,400);
    if (fastforce) this.gravityForce.x *= 2;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.curAnim = Phaser.Math.Between(1, this.maxAnim);
    this.setFrame(`Sparkle_${this.curAnim}`);
    this.updatePos();
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
  }

  calcForce () {
    if (this.k === 0) {
      this.dragForce.reset();
    }
    else {
      this.dragForce.set(this.vel.x, this.vel.y);
      Forces.linearDrag(this.k, this.vel, this.dragForce);
    }
    Forces.add([this.gravityForce, this.dragForce],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);
    this.calcForce();
    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;

    if (this.age > this.halflife) {
      this.alpha -= 0.8 * dt;
    }
    return this.age < this.lifetime;
  }

  updatePos () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }
}